import React, { Component } from "react";

class Header extends Component {
    render() {
        return (
            <div className="header">
                <div className="container-fluid">
                    <div className="wrap">
                        <div className="content">
                            <div>
                                {this.props.isCpfRegister ? 
                                    <h1>Seu gestor convidou você para o Escala</h1>
                                :
                                    <h1>Seu gestor convidou você para uma escala</h1>
                                }
                            </div> 
                            {
                                this.props.inviterUrlPic &&

                                <div className="pic">
                                    <img src={this.props.inviterUrlPic}/>
                                </div>
                            }
                        </div>
                        <label><img className="location-icon" src="assets/images/icon_location.svg"/>{this.props.location}</label>
                    </div>
                </div>
            </div>
        )
    }
}
export default Header;




// WEBPACK FOOTER //
// ./src/app/home/components/header.js